export const UPDATE_TURN = 'UPDATE_TURN';
export const UPDATE_SNAPSHOT = 'UPDATE_SNAPSHOT';
export const UPDATE_MATCH_TYPE = 'UPDATE_MATCH_TYPE';
export const UPDATE_CHECK_CODE = 'UPDATE_CHECK_CODE';
export const UPDATE_SHEET_DATA = 'UPDATE_SHEET_DATA';
export const UPDATE_SELECTED_CODE = 'UPDATE_SELECTED_CODE';
export const UPDATE_MOVABLE_TILES = 'UPDATE_MOVABLE_TILES';
export const REMOVE_CHECK = 'REMOVE_CHECK';
export const REMOVE_SHEET_DATA = 'REMOVE_SHEET_DATA';
export const REMOVE_SELECTED_CODE = 'REMOVE_SELECTED_CODE';
export const REMOVE_MOVABLE_TILES = 'REMOVE_MOVABLE_TILES';

export const TOGGLE_THINKING = 'TOGGLE_THINKING';
export const TOGGLE_FLIP = 'TOGGLE_FLIP';
export const IMPORT_GAME = 'IMPORT_GAME';
export const EXPORT_GAME = 'EXPORT_GAME';
export const SAVE_TO_LOCALSTORAGE = 'SAVE_TO_LOCALSTORAGE';

export const MEASURE_AXIS = 'MEASURE_AXIS';

export const DECIDE_SIDE = 'DECIDE_SIDE';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';
export const TOGGLE_AWAITING = 'TOGGLE_AWAITING';
export const OPEN_NETWORK_GAME = 'OPEN_NETWORK_GAME';
export const CLOSE_NETWORK_GAME = 'CLOSE_NETWORK_GAME';
export const JOIN_NETWORK_GAME = 'JOIN_NETWORK_GAME';
export const CONNECTED_PEER_NETWORK = 'CONNECTED_PEER_NETWORK';
